export const PARTY_STATUS_FALLBACK = "not_analised"

export const PARTY_STATUS_SEVERITY = {
    manually_reproved: 1,
    automatically_reproved: 1,
    reproved_by_time: 1,
    manually_challenged: 2,
    pending: 3,
    in_manual_analysis: 3,
    not_analised: 4,
    manually_approved: 5,
    automatically_approved: 5,
    approved_by_time: 5,
    not_applied: 6
}

export const normalizePartyFraudStatus = (rawStatus) =>
    Object.prototype.hasOwnProperty.call(PARTY_STATUS_SEVERITY, rawStatus)
        ? rawStatus
        : PARTY_STATUS_FALLBACK

export const partyFraudStatus = (party) =>
    normalizePartyFraudStatus(party == null ? null : party.fraudStatus)

export const aggregatePartyFraudStatus = (parties) => {
    if (!Array.isArray(parties) || parties.length === 0) return null
    let winner = null
    let winnerSeverity = Infinity
    parties.forEach((party) => {
        const status = partyFraudStatus(party)
        const severity = PARTY_STATUS_SEVERITY[status]
        if (severity < winnerSeverity) {
            winnerSeverity = severity
            winner = status
        }
    })
    return winner
}

export const aggregatePartyStatusSummary = (parties) => {
    if (!Array.isArray(parties) || parties.length === 0) return null
    const status = aggregatePartyFraudStatus(parties)
    const winnerSeverity = PARTY_STATUS_SEVERITY[status]
    const matching = parties.filter(
        (party) => PARTY_STATUS_SEVERITY[partyFraudStatus(party)] === winnerSeverity
    ).length
    return { status: status, matching: matching, total: parties.length }
}
